import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function SaturnIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M15.677 5.418c2.8-1.995 5.087-2.882 5.883-2.085.797.796-.09 3.083-2.084 5.884m0 0c-1.133 1.59-2.622 3.344-4.364 5.086-1.742 1.741-3.497 3.231-5.086 4.363m9.45-9.45c.37.868.575 1.823.575 2.826a7.2 7.2 0 0 1-10.025 6.624m-3.8-3.799c-1.994 2.8-2.88 5.088-2.084 5.884.796.797 3.083-.09 5.884-2.085m7.916-11.715A7.2 7.2 0 1 0 7.76 17.133" />
    </SvgIcon>
  );
}
